import { useEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import axios from 'axios';
import { Toaster, toast } from 'sonner';
import { ArrowLeft, Wallet } from 'lucide-react';
import DailyTracker from '../components/DailyTracker';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/sports-betting/board`;

export default function BankrollPage() {
  const [amount, setAmount] = useState('');
  const [count, setCount] = useState({ nfl: 0, cfb: 0 });
  useEffect(() => {
    axios.get(API).then((r) => {
      setAmount(String(r.data.settings?.ticket_amount ?? 10));
      setCount({ nfl: r.data.safe?.nfl?.length || 0, cfb: r.data.safe?.cfb?.length || 0 });
    }).catch(() => {});
  }, []);
  if (sessionStorage.getItem('sports_betting_authed') !== 'true') return <Navigate to="/sports-betting" replace />;
  const n = parseFloat(amount) || 0;
  const save = async () => {
    try { await axios.put(`${API}/settings`, { ticket_amount: n }); toast.success(`Saved — $${n.toFixed(2)} per ticket`); } catch (e) { toast.error(e.response?.data?.detail || e.message); }
  };
  return (
    <div className="min-h-screen bg-zinc-950 text-white p-4 md:p-6" data-testid="bankroll-page">
      <Toaster position="top-right" theme="dark" />
      <div className="max-w-xl mx-auto space-y-5">
        <Link to="/sports-betting" className="text-sm text-zinc-400 hover:text-white flex items-center gap-1" data-testid="bankroll-back"><ArrowLeft className="w-4 h-4" /> My tickets</Link>
        <h1 className="text-2xl font-bold flex items-center gap-2"><Wallet className="w-6 h-6 text-emerald-400" />Bankroll</h1>
        <DailyTracker />
        <div className="rounded-xl border border-zinc-800 bg-zinc-900/70 p-4 space-y-3">
          <label className="text-xs font-semibold text-zinc-300" htmlFor="ticket-amount">Amount per safe ticket ($)</label>
          <div className="flex gap-2">
            <input id="ticket-amount" value={amount} onChange={(e) => setAmount(e.target.value.replace(/[^0-9.]/g, ''))} inputMode="decimal"
              className="flex-1 rounded-lg border border-zinc-700 bg-zinc-950 px-3 py-2 text-lg font-mono text-white" data-testid="bankroll-amount-input" />
            <button type="button" onClick={save} disabled={!n} className="rounded-lg bg-amber-500 px-4 font-bold text-black hover:bg-amber-400 disabled:opacity-50" data-testid="bankroll-save">Save</button>
          </div>
          <p className="text-[11px] text-zinc-500">This amount shows as "Bet $X" on every safe ticket on the AI Picks page (only you see it).</p>
        </div>
        <div className="rounded-xl border border-zinc-800 bg-zinc-900/70 p-4 text-sm space-y-1" data-testid="bankroll-summary">
          <p>NFL this week: {count.nfl} tickets × ${n.toFixed(2)} = <b className="text-amber-300">${(count.nfl * n).toFixed(2)}</b></p>
          <p>College this week: {count.cfb} tickets × ${n.toFixed(2)} = <b className="text-amber-300">${(count.cfb * n).toFixed(2)}</b></p>
          <p className="text-[11px] text-zinc-500 pt-1">Tip: you don't have to play every ticket — LOCK tickets are the safest.</p>
        </div>
      </div>
    </div>
  );
}
